import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useRefreshTokenMutation } from 'app/auth/api/auth-api';
import EnterOtp from 'components/Otp/EnterOtp/EnterOtp';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppLanguage from 'hooks/useAppLanguage';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { activateEmailOtp, sendEmailOtpPin } from 'store/otp/otp-actions';
import { setActivateEmailOtpError } from 'store/otp/otp-slice';
import { RootState } from 'store/reducer';
import { profileApi, useGetProfileQuery } from 'store/slices/profile-api';
import { OTP_LENGTH, otpProcesses } from 'utils/constants';
import messages from '../../messages';

export const Route = createFileRoute('/auth/signup/_layout/verify-email')({
  // If token is valid, we immediately redirect to the next page, otherswise we show this page which displays the error
  component: VerifyEmail,
});

function VerifyEmail() {
  const dispatch = useAppDispatch();
  const language = useAppLanguage();
  const navigate = useNavigate();

  const [refreshToken] = useRefreshTokenMutation();
  const { emailOtpActivationSuccess, loading, activateEmailOtpError } =
    useSelector((rootState: RootState) => rootState.otp);

  const { data: profileData } = useGetProfileQuery();

  const sendOtp = () => {
    dispatch(sendEmailOtpPin(otpProcesses.SIGNUP_ENABLE_EMAIL_OTP));
  };

  const otpMessages = messages[language]?.otp;

  const onChangeOtp = async (otp: string) => {
    if (otp.length >= OTP_LENGTH)
      dispatch(activateEmailOtp(otp, otpProcesses.SIGNUP_ENABLE_EMAIL_OTP));
    if (otp.length < 6) dispatch(setActivateEmailOtpError(false));
  };

  useEffect(() => {
    if (emailOtpActivationSuccess) {
      // Optimistically update the profile status to make redirect to the next page work
      // This should be reworked once we also use RTK Query for OTP
      dispatch(
        profileApi.util.updateQueryData(
          'getProfileStatus',
          undefined,
          previousData => {
            return {
              ...previousData,
              emailVerified: true,
            };
          },
        ),
      );

      navigate({ to: '/auth/signup/account-details' });
    }
  }, [emailOtpActivationSuccess]);

  useEffect(() => {
    const removeOtpError = () => {
      dispatch(setActivateEmailOtpError(false));
    };
    return () => removeOtpError();
  }, []);

  return (
    <>
      <div className="flex justify-center items-center flex-col mb-8">
        <EnterOtp
          title={otpMessages?.emailTitle}
          subtitle={otpMessages?.emailSubtitle(profileData?.email)}
          onChangeOtp={onChangeOtp}
          resendOtp={() => sendOtp()}
          darkText
          hasError={activateEmailOtpError}
          isLoading={loading}
          type="EMAIL"
          process={otpProcesses.SIGNUP_ENABLE_EMAIL_OTP}
        />
      </div>
    </>
  );
}
